import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const columns = [
  {
    id: "date",
    label: "Date",
    cell: (row: any) => format(new Date(row.created_at), "Pp", { locale: fr }),
  },
  {
    id: "type",
    label: "Type",
    cell: (row: any) => {
      const types = {
        sale: "Vente",
        expense: "Dépense",
        restock: "Réapprovisionnement",
        loss: "Perte",
      };
      return types[row.transaction_type as keyof typeof types] || row.transaction_type;
    },
  },
  {
    id: "amount",
    label: "Montant",
    cell: (row: any) => `${row.total_amount.toLocaleString()} FCFA`,
  },
  {
    id: "quantity",
    label: "Quantité",
    cell: (row: any) => row.quantity,
  },
];